import { cn } from "@/lib/utils";

const GlassCard = ({ children, className }) => {
    return (
        <div
            className={cn(
                "glass-card",
                className
            )}
        >
            {children}
        </div>
    );
};

export default GlassCard;
